import React from "react"
import { Button } from "@mui/material";
import { Link } from "react-router-dom";

function accessCheck(access, route_path = "") {
    if (!access || !access["routes"]) return false;
    if (access['isAdmin'] === true || access["routes"] === true) return true;
    return access["routes"] && access["routes"].includes(route_path);
}

export default function NavbarButton({access, path, children}){
    return(
        accessCheck(access, path) 
        ?
            <Button
                component={Link}
                to={path}
                style={{ color: 'white', fontWeight: 'normal', textAlign: 'center' }}
            >
                {children}
            </Button>
        : 
        <></>
    )
}